module.exports = __webpack_public_path__ + "img/ISc7Hl9lKgQ.6ad0d2ad.jpg";